import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createFinanceRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/finance/trip_report_by_staff",
    component: lazyRouteComponent(
      () => import("pages/finance/trip_report_by_staff"),
    ),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/finance/inventory",
    component: lazyRouteComponent(() => import("pages/finance/inventory")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/finance/staff_change",
    component: lazyRouteComponent(() => import("pages/finance/staff_change")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/finance/invoice_month",
    component: lazyRouteComponent(() => import("pages/finance/invoice_month")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/finance/invoice",
    component: lazyRouteComponent(() => import("pages/finance/invoice")),
  }),
];
